import React from 'react';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { CustomBreadcrumbs, CustomList } from 'candy-commons-components';
import {
    TextField,
    useTranslate,
    BooleanField,
    NumberField,
} from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';

const HomeSectionCmsList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.ecommerce-home-sections.name'),
            url: '',
            icon: <ViewModuleIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                exporter={false}
                perPage={25}
                sort={{ field: 'order', order: 'ASC' }}
                {...props}
                pagination={
                    <DynamoPagination resource="ecommerce-home-sections" />
                }
                bulkActionButtons={false}
            >
                <CustomDatagrid selectable rowClick="edit" choiceColumns>
                    <TextField source="section" />
                    <NumberField source="order" />
                    <BooleanField source="active" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};

export default HomeSectionCmsList;
